<div class="grid grid-cols-[300px_auto] grid-rows-[74px_1fr] overflow-auto grid-container" #gridContainer>
  <!-- left-top -->
  <div
    class="sticky top-0 left-0 z-30 filter-cell-row bg-white border-b border-r border-solid border-c-gb shadow-[5px_0_5px_-2px_rgba(0,0,0,.04)]">
    <div class="flex flex-row border-b border-solid border-c-gb h-[50px]">
      <div class="sticky-left-cell-1">
        <ng-content select=".filter-tpl"></ng-content>
      </div>
      <div
        class="sticky-left-cell-2 text-[10px] text-c-l2 text-center !leading-[12px]"
        [innerHTML]="'word.basic_price' | translate"></div>
    </div>
    <div class="flex flex-row leading-[24px] text-[10px] text-c-l2">
      <div class="sticky-left-cell-1 px-[10px]">
        {{ "word.empty_house" | translate }}
        <!-- Vacant -->
      </div>
      <div class="sticky-left-cell-2"></div>
    </div>
  </div>

  <!-- right-top -->
  <div
    class="sticky top-0 date-cell-row z-20 border-b border-solid border-c-gb bg-white flex flex-row"
    [style.width]="listOfAllDates.length * cellWidth">
    <!-- 日期选择指示器 -->
    <!-- @if (selectStatus !== "none") {
      <div class="select-bar" [ngStyle]="selectedRectStyle"></div>
    } -->

    <!-- 加载占位符 - 左 -->
    <div class="pr-2" [style.width]="cursor * cellWidth">
      <div class="h-[4px] w-full bg-c-gb rounded mt-[34px] animate-pulse"></div>
    </div>

    <div
      *ngFor="let date of listOfDatesInView; trackBy: trackDate"
      class="border-l border-solid border-c-gb text-center"
      [ngClass]="{
        '!border-l-[#ced5df]': date.day === 0,
        '!border-l-[#48ca93]': date.isCurrentDay
      }"
      [ngStyle]="{ width: cellWidth }">
      <host-calendar-date-cell
        [date]="date"
        [showMonth]="$any(date).isFirstDayInView || date.number === 1"></host-calendar-date-cell>
      <div class="text-[10px] text-c-d2 leading-[24px]">
        {{ getFreeHouseCount(date.date) }}
      </div>
    </div>

    <!-- 加载占位符 - 右 -->
    <div class="flex-1 pl-2">
      <div class="h-[4px] w-full bg-c-gb rounded mt-[34px] animate-pulse"></div>
    </div>
  </div>

  <ng-container *ngIf="listOfHouses?.[0] || listOfHouses?.[1]">
    <!-- left-bottom  -->
    <div
      #houseBody
      class="sticky left-0 house-cell-col z-20 pb-[80px] border-b border-r border-solid border-c-gb bg-white shadow-[5px_0_5px_-2px_rgba(0,0,0,.04)]">
      <ng-container *ngFor="let item of listOfHouses; trackBy: $any(trackRenderId)">
        @switch (item.r_type) {
          @case ("bar") {
            <div class="flex flex-row type-row">
              <div class="sticky-left-cell-1 px-[10px] text-[13px] text-c-d2">
                {{ item.b_title }}
              </div>
              <div class="sticky-left-cell-2"></div>
            </div>
          }

          @case ("group") {
            <div
              class="group-cell-height px-[10px] border-b border-solid border-c-gb text-ellipsis overflow-hidden whitespace-nowrap">
              <a
                class="text-[13px] text-c-d2 font-semibold"
                [routerLink]="item.type === 1 ? '/app/room_types/detail' : '/app/properties/detail'"
                [queryParams]="{ id: item.p_id }">
                {{ item.p_title }}
              </a>
            </div>
          }

          @case ("member") {
            <ng-template [ngTemplateOutlet]="houseCell" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
          }
        }
      </ng-container>
    </div>

    <!-- right-bottom -->
    <div #calendarBody class="calendar-cell-row-col pb-[80px]" [style.width]="listOfAllDates.length * cellWidth">
      <ng-container *ngFor="let item of listOfHouses; trackBy: $any(trackRenderId)">
        @switch (item.r_type) {
          @case ("bar") {
            <div class="type-row flex flex-row">
              <!-- 占位-左 -->
              <div class="pr-2" [style.width]="cursor * cellWidth"></div>
              <div
                class="type-cell"
                [ngClass]="{
                  '!border-l-[#ced5df]': date.day === 0,
                  '!border-l-[#48ca93]': date.isCurrentDay
                }"
                [ngStyle]="{ width: cellWidth, left: date.offsetStart * cellWidth }"
                *ngFor="let date of listOfDatesInView; let j = index; trackBy: trackDate"></div>
              <!-- 占位-右 -->
              <div class="flex-1"></div>
            </div>
          }
          @case ("group") {
            <div class="relative group-cell-height bg-white border-bottom flex flex-row">
              <!-- 占位-左 -->
              <div class="pr-2" [style.width]="cursor * cellWidth"></div>
              <div
                class="group-cell-height border-left"
                [ngClass]="{
                  '!border-l-[#ced5df]': date.day === 0,
                  '!border-l-[#48ca93]': date.isCurrentDay
                }"
                [ngStyle]="{ width: cellWidth }"
                *ngFor="let date of listOfDatesInView; trackBy: trackDate"></div>
              <!-- 占位-右 -->
              <div class="flex-1"></div>
            </div>
          }

          @case ("member") {
            <ng-template [ngTemplateOutlet]="calendarRow" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
          }
        }
      </ng-container>
    </div>

    <div class="absolute bottom-[30px] right-[30px]">
      <ng-content></ng-content>
    </div>
  </ng-container>

  <!-- empty   -->
  <div class="absolute left-0 right-0 top-[74px]">
    <ng-content select=".empty-content"></ng-content>
  </div>
</div>

<ng-template #houseCell let-house>
  <div>
    <div
      class="house-item flex flex-row body-cell-height border-b border-solid border-c-gb cursor-pointer"
      [attr.data-key]="house.c_id">
      @if (houseIdsInViewport.has(house.c_id)) {
        <!-- 房间信息格 -->
        <div class="sticky-left-cell-1 body-cell-height flex flex-row items-center px-[10px]">
          <img
            [src]="(house.thirdparty_type | thirdparty)?.icon_color"
            alt=""
            class="w-[16px] h-[16px] mr-2 shrink-0" />
          <p
            nz-paragraph
            [nzEllipsis]="true"
            [nzEllipsisRows]="3"
            nz-popover
            nzPopoverTrigger="hover"
            [nzPopoverContent]="houseOverview"
            class="text-[12px] text-c-d3 leading-[13px]">
            {{ house.c_title }}
          </p>

          <ng-template #houseOverview>
            <div class="house-overview-content">
              <div class="flex flex-row items-center">
                <img
                  src="/assets/status/placeholder.png"
                  hostPlaceholder
                  [delaySrc]="house.c_cover_url"
                  alt=""
                  class="w-[60px] h-[40px] mr-[12px] rounded" />
                <div>
                  <div class="flex flex-row items-center">
                    <a [href]="house.housing_link" target="_blank" class="text-m ellipsis-line-2">{{
                      house.thirdparty_house_title
                    }}</a>

                    <i
                      *ngIf="house.thirdparty_type === Platform.Vrbo || house.thirdparty_type === Platform.Airbnb"
                      class="text-[16px] text-primary ml-2 cursor-pointer"
                      nz-icon
                      nzType="setting"
                      nzTheme="outline"
                      (click)="onClickHouse(house, house.c_parent)"></i>
                  </div>

                  <div class="flex flex-row items-center">
                    <img
                      class="w-[16px] h-[16px] rounded-full"
                      [attr.src]="(house.thirdparty_type | thirdparty)?.icon_color" />
                    <span class="text-s ml-1">{{ house.account_username }}</span>
                  </div>
                </div>
              </div>
              @if (house.c_rate_plan_desc) {
                <div class="mt-2 text-m">{{ house.c_rate_plan_desc }}</div>
              }
            </div>
          </ng-template>
        </div>
        <!-- 房间价格格 -->
        <div class="sticky-left-cell-2 body-cell-height">
          <a class="text-center" href="javascript:void(0)" (click)="onClickHouse(house, house.c_parent, 0)">
            @if (housesPriceMap[house.id]?.daily_price) {
              <div class="price text-m text-c-d2">
                {{ housesPriceMap[house.id]?.daily_price }}
              </div>
            } @else {
              <div class="price text-[10px] text-c-l2 leading-normal">N/A</div>
            }
            <div class="price currency text-[10px] text-c-l2">
              {{ housesPriceMap[house.id]?.currency_type }}
            </div>
          </a>
        </div>
      } @else {
        <div
          class="body-cell-height border-b border-solid border-c-gb w-full flex space-x-4 items-center p-4 animate-pulse">
          <div class="rounded-full bg-c-gb h-8 w-8"></div>
          <div class="flex-1">
            <div class="h-2 w-full bg-c-gb rounded"></div>
            <div class="h-2 w-full bg-c-gb rounded mt-1"></div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #calendarRow let-row let-index="index">
  <div class="calendar-body-row relative body-cell-height bg-white flex flex-row" [attr.data-key]="row.c_id">
    @if (houseIdsInViewport.has(row.c_id)) {
      <!-- 订单条 -->
      <div
        *ngFor="let reservation of reservationMap[row.id] | values"
        class="reservation-bar"
        [style.left]="cellWidth * reservation.__index + 2"
        [style.width]="cellWidth * reservation.__nights - 2"></div>
      <!-- 操作气泡 -->
      <div
        class="operate-pop"
        *ngIf="displayShortcutPop && selectStatus === 'done' && listOfSelectedData?.payload?.c_id === row.c_id"
        [style.left]="selectedRectStyle.left + selectedRectStyle.width - cellWidth / 2">
        <div class="content">
          <div class="arrow"></div>
          @if (dataOfShortcutPop.type === 0) {
            <div class="item" (click)="_changeTab('channel-price')">
              {{ "component.multi_house_price_calendar.change_price" | translate }}
              <!-- 改价 -->
            </div>
            <div
              class="item"
              (click)="changeHouseAvailable(1)"
              *ngIf="dataOfShortcutPop.status === 'diff' || dataOfShortcutPop.status === 'close'">
              {{ "calendar.pop.status_on" | translate }}
              <!-- 打开 -->
            </div>
            <div
              class="item"
              (click)="changeHouseAvailable(0)"
              *ngIf="dataOfShortcutPop.status === 'diff' || dataOfShortcutPop.status === 'open'">
              {{ "calendar.pop.status_off" | translate }}
              <!-- 关闭 -->
            </div>
          } @else {
            <div class="item" (click)="_changeTab('channel-price')">
              {{ "component.multi_house_price_calendar.change_price" | translate }}
              <!-- 改价 -->
            </div>
            <div class="item" (click)="_changeTab('channel-status')">
              {{ "component.multi_house_price_calendar.change_inventory" | translate }}
              <!-- 改库存 -->
            </div>
          }
        </div>
      </div>
      <!-- 日历格子 -->
      <!-- 加载占位符 - 左 -->
      <div class="pr-2" [style.width]="cursor * cellWidth">
        <div class="h-[4px] w-full bg-c-gb rounded mt-[34px] animate-pulse"></div>
      </div>
      <div
        *ngFor="let date of listOfDatesInView; let m = index; trackBy: trackDate"
        class="body-cell body-cell-height"
        [ngClass]="{
          '!border-l-[#ced5df]': date.day === 0,
          '!border-l-[#48ca93]': date.isCurrentDay,
          empty: !calendarMap[row.unique_key] || !calendarMap[row.unique_key][date.date],
          closed: calendarMap[row.unique_key]?.[date.date]?.inventory === 0 || date.isPastDate
        }"
        [ngStyle]="{ width: cellWidth }"
        [attr.data-date]="date.date"
        (click)="onClickCell(row, date)"
        (mouseenter)="onHoverCell(row, date)">
        <!-- 规则图标 -->
        @if (calendarMap[row.unique_key]?.[date.date]?.setting; as ruleSetting) {
          <div class="rules-icons" nz-popover [nzPopoverTitle]="null" [nzPopoverContent]="rulePopTpl">
            @if (ruleSetting?.showMoon) {
              <div class="rules-item">
                <img class="rules-icon" src="/assets/v4/icon-calendar-moon.svg" alt="" />
                @if (ruleSetting?.moonCount; as moonCount) {
                  <span class="text-[10px] text-[#586167]">{{ moonCount }}</span>
                }
              </div>
            }

            @if (ruleSetting?.showLock) {
              <div class="rules-item">
                <img class="rules-icon" src="/assets/v4/icon-calendar-lock.svg" alt="" />
              </div>
            }

            @if (ruleSetting?.showFlag) {
              <div class="rules-item">
                <img class="rules-icon" src="/assets/v4/icon-calendar-flag.svg" alt="" />
              </div>
            }
          </div>

          <ng-template #rulePopTpl>
            <div>
              <!-- 规则-月亮 -->
              @if (ruleSetting?.min_stay_on_arrival; as min_soa) {
                <div>
                  {{ "calendar-rules_min_stay_on_arrival" | translate }}
                  <!-- Min stay on arrival: -->
                  {{ min_soa }}
                </div>
              }
              @if (ruleSetting?.min_stay_through; as min_st) {
                <div>
                  {{ "calendar-rules_min_stay_through" | translate }}
                  <!-- Min stay through: -->
                  {{ min_st }}
                </div>
              }
              @if (ruleSetting?.max_stay_on_arrival; as max_soa) {
                <div>
                  {{ "calendar-rules_max_stay_on_arrival" | translate }}
                  <!-- Max stay on arrival: -->
                  {{ max_soa }}
                </div>
              }
              @if (ruleSetting?.max_stay_through; as max_st) {
                <div>
                  {{ "calendar-rules_max_stay_through" | translate }}
                  <!-- Max stay through: -->
                  {{ max_st }}
                </div>
              }
              @if (ruleSetting?.exact_stay_on_arrival; as exact_soa) {
                <div>
                  {{ "calendar-rules_exact_stay_on_arrival" | translate }}
                  <!-- Exact stay on arrival: -->
                  {{ exact_soa }}
                </div>
              }

              <!-- 锁 -->
              @if (ruleSetting?.closed_on_arrival; as coa) {
                <div>
                  {{ "calendar-rules_closed_on_arrival" | translate }}
                  <!-- Closed on arrival: -->
                  {{ coa ? "Enabled" : "Disabled" }}
                </div>
              }
              @if (ruleSetting?.closed_on_departure; as cod) {
                <div>
                  {{ "calendar-rules_closed_on_departure" | translate }}
                  <!-- Closed on departure: -->
                  {{ cod ? "Enabled" : "Disabled" }}
                </div>
              }

              <!-- 旗子 -->
              @if (ruleSetting?.min_advance_res; as min_ar) {
                <div>
                  {{ "calendar-rules_min_advance_res" | translate }}
                  <!-- Min advance res: -->
                  {{ min_ar }}
                </div>
              }
              @if (ruleSetting?.max_advance_res; as max_ar) {
                <div>
                  {{ "calendar-rules_max_advance_res" | translate }}
                  <!-- Max advance res: -->
                  {{ max_ar }}
                </div>
              }
              @if (ruleSetting?.seasonal_rule; as sr) {
                <div>
                  {{ "calendar-rules_seasonal_rule" | translate }}
                  <!-- Seasonal rule: -->
                  {{ sr }}
                </div>
              }
            </div>
          </ng-template>
        }

        <!-- 价格 -->
        <span
          class="price w-full ellipsis-line-2 text-center text-c-d2"
          [ngClass]="{
            'text-c-l2': row.c_readonly,
            'scale-[0.8]': getPrice(row, date.date)?.length >= 7
          }">
          {{ getPrice(row, date.date) }}
        </span>
        <span class="stock" *ngIf="row.type === 1 && displayStock"> [{{ getInventory(row, date.date) }}] </span>
        <div class="right-icon-wrapper">
          <div
            class="oversale"
            *ngIf="housesOversellMap[row.unique_key]?.[date.date]"
            nz-popover
            nzTrigger="hover"
            [nzPopoverTitle]="''"
            [nzPopoverContent]="houseOversaleTpl"
            class="oversale"></div>
        </div>

        <!-- 超售模板 -->
        <ng-template #houseOversaleTpl>
          <host-auto-popover
            type="oversale"
            (onClickEditOversale)="onClickHouse(row, row.c_parent, 0)"></host-auto-popover>
        </ng-template>
      </div>
      <!-- 加载占位符 - 右 -->
      <div class="pl-2 flex-1">
        <div class="h-[4px] w-full bg-c-gb rounded mt-[34px] animate-pulse"></div>
      </div>
      <!-- 选择框 -->
      <div
        *ngIf="selectStatus !== 'none' && listOfSelectedData?.payload?.c_id === row.id"
        class="select-rect"
        [ngStyle]="selectedRectStyle"></div>
    } @else {
      <div class="body-cell-height border-b border-solid border-c-gb flex flex-row items-center w-full">
        <div class="animate-pulse h-[4px] w-full bg-c-gb"></div>
      </div>
    }
  </div>
</ng-template>
